import { render, staticRenderFns } from "./u-switch.vue?vue&type=template&id=2fbcbd5b&scoped=true&"
import script from "./u-switch.vue?vue&type=script&lang=js&"
export * from "./u-switch.vue?vue&type=script&lang=js&"
import style0 from "./u-switch.vue?vue&type=style&index=0&id=2fbcbd5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbcbd5b",
  null
  
)

export default component.exports